export default "__VITE_ASSET__D0OZpC8g__"